import gql from 'graphql-tag'
import { fragments as tagFragments } from '@/graphql/queries/tags'

export const DEFAULT_BOOKMARK_VALUES = {
    url: '',
    title: '',
    description: '',
    faviconUrl: '',
    offline: false,
    parsed: false,
    imageUrl: '',
    tags: [],
    suggestedTags: [],
    images: []
}

export const DEFAULT_BOOKMARK_FORM_VALUES = {
    id: null,
    url: '',
    title: '',
    description: '',
    faviconUrl: '',
    offline: false,
    parsed: false,
    imageUrl: '',
    tagList: [],
    suggestedTags: [],
    images: []
}

export const fragments = {
  bookmark: gql`
    fragment bookmarkFields on Bookmark {
      id
      url
      title
      description
      faviconUrl
      offline
      parsed
      imageUrl
      tags {
        id
        name
      }
      suggestedTags
      images
      updatedAt
      createdAt
    },
  `,
  bookmarkPreview: gql`
    fragment bookmarkPreviewFields on BookmarkPreview {
      id
      url
      title
      description
      faviconUrl
      offline
      parsed
      imageUrl
      tagList
      suggestedTags
      images
    },
  `
}

export const GET_ALL_BOOKMARKS_QUERY = gql`
  query bookmarks($page: Int, $filter: [String!], $order: String, $direction: String) {
    bookmarks(page: $page, limit: 10, filter: $filter, direction: $direction, order: $order) {
      collection {
        ...bookmarkFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.bookmark}
`

export const GET_ALL_BOOKMARKS_WITH_ALL_TAGS_QUERY = gql`
  query bookmarks($page: Int, $filter: [String!], $order: String, $direction: String) {
    bookmarks(page: $page, limit: 10, filter: $filter, direction: $direction, order: $order) {
      collection {
        ...bookmarkFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
    tags(page: 0, filter: $filter, direction: $direction, order: $order) {
      collection {
        ...tagFields
      }
    }
  }
  ${fragments.bookmark}
  ${tagFragments.tag}
`

export const GET_BOOKMARK_QUERY = gql`
  query bookmarks($id: Int!) {
    bookmark(id: $id) {
      ...bookmarkFields
    }
  }
  ${fragments.bookmark}
`

export const GET_BOOKMARK_BY_URL_QUERY = gql`
  query bookmarks($url: String!, $parse: String) {
    bookmarkByUrl(url: $url, parse: $parse) {
      ...bookmarkPreviewFields
    }
  }
  ${fragments.bookmarkPreview}
`

export const PARSE_URL_QUERY = gql`
  query parseBookmark($url: String!) {
    parseBookmark(url: $url) {
      ...bookmarkPreviewFields
    }
  }
  ${fragments.bookmarkPreview}
`

export const CREATE_BOOKMARK_MUTATION = gql`
  mutation createBookmark($bookmark: BookmarkInput!) {
    bookmarks: createBookmark(bookmark: $bookmark) {
      ...bookmarkFields
    }
  }
  ${fragments.bookmark}
`

export const UPDATE_BOOKMARK_MUTATION = gql`
  mutation updateBookmark($id: Int!, $bookmark: BookmarkInput!) {
    bookmarks: updateBookmark(id: $id, bookmark: $bookmark) {
      ...bookmarkFields
    }
  }
  ${fragments.bookmark}
`

export const DELETE_BOOKMARK_MUTATION = gql`
  mutation deleteBookmark($ids: [Int!]!) {
    bookmarks: deleteBookmark(ids: $ids) {
      ...bookmarkFields
    }
  }
  ${fragments.bookmark}
`

export const REPARSE_BOOKMARK_MUTATION = gql`
  mutation reparseBookmark($id: Int!) {
    bookmark: reparseBookmark(id: $id) {
      ...bookmarkFields
    }
  }
  ${fragments.bookmark}
`

export const WAYBACK_BOOKMARK_MUTATION = gql`
  mutation waybackBookmark($id: Int!) {
    wayback: waybackBookmark(id: $id)
  }
`
